import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className='footer-container'>
      <div className='footer-inner'>
        <section className='footer-subscription'>
          <div className="footer-logo-section">
            <div className="footer-logo-container">
              <Link to="/" className="footer-logo-link">
                <img src={process.env.PUBLIC_URL + '/images/newLogo.svg'} width="70px" alt="Logo" className="footer-mark" />
              </Link>
              <h5>TE(x)US L&Delta;B</h5>
            </div>
            <span className="footer-logo-divider" aria-hidden="true" />
            <Link to="/" className="footer-jsg-link">
              <img src={process.env.PUBLIC_URL + '/images/jsg_white_digital.png'} width="240px" alt="Logo" className="footer-jsg" />
            </Link>
          </div>
        </section>

        <div className='footer-links'>
          <div className='footer-link-wrapper'>
            <div className='footer-link-items'>
              <h2>About Us</h2>
              <Link to='/projects'>Research</Link>
              <Link to='/News'>News</Link>
              <Link to='/Team'>Our Team</Link>
              <Link to='/Publications'>Publications</Link>
            </div>
            <div className='footer-link-items'>
              <h2>Contact Us</h2>
              <a href='mailto:dev.niyogi@jsg.utexas.edu'>Email</a>

            </div>
          </div>
          <div className='footer-link-wrapper'>

            <div className='footer-link-items'>
              <h2>Social Media</h2>
              <a href='https://www.linkedin.com/in/texus/' target='_blank' rel='noopener noreferrer'>Linkedin</a>
              <a href='https://scholar.google.com/citations?user=Ixl0-pAAAAAJ&hl=en' target='_blank' rel='noopener noreferrer'>Google Scholar</a>

            </div>
          </div>
        </div>

        <section className='social-media'>
          <div className='social-media-wrap'>
            <small className='website-rights'>TExUS © 2023</small>
            <div className='social-icons'>
              <Link
                className='social-icon-link facebook'
                to='/'
                target='_blank'
                aria-label='Facebook'
              >
                <i className='fab fa-facebook-f' />
              </Link>
              <Link
                className='social-icon-link instagram'
                to='/'
                target='_blank'
                aria-label='Instagram'
              >
                <i className='fab fa-instagram' />
              </Link>
              <Link
                className='social-icon-link youtube'
                to='/'
                target='_blank'
                aria-label='Youtube'
              >
                <i className='fab fa-youtube' />
              </Link>
              <Link
                className='social-icon-link twitter'
                to='/'
                target='_blank'
                aria-label='Twitter'
              >
                <i className='fab fa-twitter' />
              </Link>
              <Link
                className='social-icon-link twitter'
                to='/'
                target='_blank'
                aria-label='LinkedIn'
              >
                <i className='fab fa-linkedin' />
              </Link>
            </div>
          </div>
        </section>
      </div>
    </footer>
  );
}

export default Footer;
